import { render, staticRenderFns } from "./Interno.vue?vue&type=template&id=06a355d0&scoped=true"
import script from "./Interno.vue?vue&type=script&lang=js"
export * from "./Interno.vue?vue&type=script&lang=js"
import style0 from "./Interno.vue?vue&type=style&index=0&id=06a355d0&prod&lang=css"
import style1 from "./Interno.vue?vue&type=style&index=1&id=06a355d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a355d0",
  null
  
)

export default component.exports